import { render, staticRenderFns } from "./newsHot.vue?vue&type=template&id=2ad46b2c"
import script from "./newsHot.vue?vue&type=script&lang=js"
export * from "./newsHot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports